module.exports =
/******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId]) {
/******/ 			return installedModules[moduleId].exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			i: moduleId,
/******/ 			l: false,
/******/ 			exports: {}
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.l = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// define getter function for harmony exports
/******/ 	__webpack_require__.d = function(exports, name, getter) {
/******/ 		if(!__webpack_require__.o(exports, name)) {
/******/ 			Object.defineProperty(exports, name, { enumerable: true, get: getter });
/******/ 		}
/******/ 	};
/******/
/******/ 	// define __esModule on exports
/******/ 	__webpack_require__.r = function(exports) {
/******/ 		if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
/******/ 			Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
/******/ 		}
/******/ 		Object.defineProperty(exports, '__esModule', { value: true });
/******/ 	};
/******/
/******/ 	// create a fake namespace object
/******/ 	// mode & 1: value is a module id, require it
/******/ 	// mode & 2: merge all properties of value into the ns
/******/ 	// mode & 4: return value when already ns object
/******/ 	// mode & 8|1: behave like require
/******/ 	__webpack_require__.t = function(value, mode) {
/******/ 		if(mode & 1) value = __webpack_require__(value);
/******/ 		if(mode & 8) return value;
/******/ 		if((mode & 4) && typeof value === 'object' && value && value.__esModule) return value;
/******/ 		var ns = Object.create(null);
/******/ 		__webpack_require__.r(ns);
/******/ 		Object.defineProperty(ns, 'default', { enumerable: true, value: value });
/******/ 		if(mode & 2 && typeof value != 'string') for(var key in value) __webpack_require__.d(ns, key, function(key) { return value[key]; }.bind(null, key));
/******/ 		return ns;
/******/ 	};
/******/
/******/ 	// getDefaultExport function for compatibility with non-harmony modules
/******/ 	__webpack_require__.n = function(module) {
/******/ 		var getter = module && module.__esModule ?
/******/ 			function getDefault() { return module['default']; } :
/******/ 			function getModuleExports() { return module; };
/******/ 		__webpack_require__.d(getter, 'a', getter);
/******/ 		return getter;
/******/ 	};
/******/
/******/ 	// Object.prototype.hasOwnProperty.call
/******/ 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "";
/******/
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(__webpack_require__.s = 3);
/******/ })
/************************************************************************/
/******/ ([
/* 0 */
/***/ (function(module, exports) {

module.exports = require("source-map-support/register");

/***/ }),
/* 1 */
/***/ (function(module, exports) {

module.exports = require("omit-deep");

/***/ }),
/* 2 */
/***/ (function(module, exports) {

module.exports = require("graphql-tag");

/***/ }),
/* 3 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, "registerMarkup", function() { return /* binding */ registerMarkup; });
__webpack_require__.d(__webpack_exports__, "registerApolloClient", function() { return /* binding */ registerApolloClient; });
__webpack_require__.d(__webpack_exports__, "registerApolloBatchClient", function() { return /* binding */ registerApolloBatchClient; });
__webpack_require__.d(__webpack_exports__, "getSettings", function() { return /* binding */ getSettings; });

// EXTERNAL MODULE: external "source-map-support/register"
var register_ = __webpack_require__(0);

// EXTERNAL MODULE: external "omit-deep"
var external_omit_deep_ = __webpack_require__(1);
var external_omit_deep_default = /*#__PURE__*/__webpack_require__.n(external_omit_deep_);

// EXTERNAL MODULE: external "graphql-tag"
var external_graphql_tag_ = __webpack_require__(2);
var external_graphql_tag_default = /*#__PURE__*/__webpack_require__.n(external_graphql_tag_);

// CONCATENATED MODULE: ./utils/index.js

const ucFirst = str => {
  return str[0].toUpperCase() + str.slice(1);
};
const isBool = str => Object.prototype.toString.call(str) === "[object Boolean]";
// CONCATENATED MODULE: ./libs/required.js

const required = param => {
  throw new Error(`Missing parameter: ${param}`);
};
/* harmony default export */ var libs_required = (required);
// CONCATENATED MODULE: ./Markup.js






class Markup_Markup {
  constructor(options = {}) {
    const {
      queries,
      mutations,
      validations
    } = options;
    this.rawFuncs = {};
    this.queryFragments = queries || {};
    this.mutationFragments = mutations || {};
    this.validations = validations || {};
    this.fragments = {
      ...this.queryFragments,
      ...this.mutationFragments
    };
    this.queryOperations = {};
    this.mutationOperations = {};
    this.__init();
  }
  __init() {
    const queryFragmentNames = Object.keys(this.queryFragments);
    const mutationFragmentNames = Object.keys(this.mutationFragments);
    const operationNames = [];
    queryFragmentNames.forEach(name => operationNames.push({
      name: name.replace("QueryFragment", "").replace("Fragment", ""),
      type: "query"
    }));
    mutationFragmentNames.forEach(name => operationNames.push({
      name: name.replace("MutationFragment", "").replace("Fragment", ""),
      type: "mutation"
    }));
    operationNames.forEach(({
      name,
      type
    }) => this[`${type}Operations`][name] = this.__baseFn(name, type));
    const operations = Object.assign({}, this.queryOperations, this.mutationOperations);
    for (const operationName in operations) {
      const isQuery = !!this.queryOperations[operationName];
      const fn = (variables, options = {}) => {
        try {
          const isQuery = !!this.queryOperations[operationName];
          const fragment = isQuery ? this.queryFragments[`${operationName}QueryFragment`] || this.queryFragments[operationName] || this.queryFragments[`${operationName}Fragment`] : this.mutationFragments[`${operationName}MutationFragment`] || this.mutationFragments[operationName] || this.mutationFragments[`${operationName}Fragment`];
          if (!options.fragment) options.fragment = fragment;
          return this[isQuery ? "query" : "mutation"](variables, options, operationName);
        } catch (err) {
          throw err;
        }
      };
      this[operationName] = fn;
      if (isQuery) this[`get${ucFirst(operationName)}`] = fn;
    }
  }
  __baseFn(name, type) {
    return async fragment => {
      const {
        markup
      } = getSettings();
      try {
        var {
          default: markupJson
        } = await markup[name]();
      } catch (err) {
        throw err;
      }
      if (isBool(fragment)) return external_graphql_tag_default.a`
					${this.__generateOperationMarkupString(type, markupJson)}
				`;
      return external_graphql_tag_default.a`
				${fragment}
				${this.__generateOperationMarkupString(type, markupJson, fragment)}
			`;
    };
  }
  __generateOperationMarkupString(type, json, fragment) {
    const {
      name,
      args
    } = json;
    if (fragment) {
      const fragmentName = fragment.definitions[0].name.value;
      if (args.length === 0) return `
				${type} ${ucFirst(name)} {
					${name} {
						...${fragmentName}
					}
				}
			`;
      return `
            ${type} ${ucFirst(name)}(${args.map(arg => `$${arg.name}: ${arg.type}`)}) {
                ${name}(${args.map(arg => `${arg.name}: $${arg.name}`)}) {
                    ...${fragmentName}
                }
            }
        `;
    }
    if (args.length === 0) return `
			${type} ${ucFirst(name)} {
				${name}
			}
		`;
    return `
        ${type} ${ucFirst(name)}(${args.map(arg => `$${arg.name}: ${arg.type}`)}) {
            ${name}(${args.map(arg => `${arg.name}: $${arg.name}`)}) 
        }
    `;
  }
  async query(variables = {}, {
    fetchPolicy,
    errorPolicy,
    returnQuery,
    validations,
    onLoading = () => {},
    batch = false,
    context,
    fragment,
    keepTypeName,
    client: customClient
  } = {}, name = libs_required`name`) {
    try {
      const {
        apolloClient,
        apolloBatchClient
      } = getSettings();
      if (this.queryOperations[name]) {
        var query = await this.queryOperations[name](fragment);
      } else {
        const operation = this.__baseFn(name, "query");
        var query = await operation(fragment);
      }
      const validation = (validations || this.validations)[`${name}Validation`] || (validations || this.validations)[`${name}QueryValidation`];
      if (!query) {
        throw new Error(`Must have ${name} Query`);
      }
      if (returnQuery) return {
        query,
        validation
      };
      if (validation) try {
        this.validate(query, variables, validation);
      } catch (err) {
        console.error(err);
        throw err;
      }
      onLoading(true);
      const apollo = customClient || (batch ? apolloBatchClient : apolloClient);
      const {
        data,
        errors
      } = await apollo.query(Object.assign({
        query,
        variables,
        context
      }, fetchPolicy ? {
        fetchPolicy
      } : {}, errorPolicy ? {
        errorPolicy
      } : {}));
      if (errors && errors.length > 0) {
        throw new Error(errors[0].message);
      }
      if (!keepTypeName) external_omit_deep_default()(data, "__typename");
      onLoading(false);
      if (fetchPolicy === "network-only" || !fetchPolicy && apollo.defaultOptions.query.fetchPolicy === "network-only") {
        await apollo.cache.reset();
      }
      return data[name];
    } catch (e) {
      onLoading(false);
      throw e;
    }
  }
  async mutation(variables = {}, {
    fetchPolicy,
    errorPolicy,
    returnMutation,
    onLoading = () => {},
    validations,
    batch = false,
    context,
    fragment,
    keepTypeName,
    client: customClient
  }, name = libs_required`name`) {
    try {
      const {
        apolloClient,
        apolloBatchClient
      } = getSettings();
      if (this.mutationOperations[name]) {
        var mutation = await this.mutationOperations[name](fragment);
      } else {
        const operation = this.__baseFn(name, "mutation");
        var mutation = await operation(fragment);
      }
      const validation = (validations || this.validations)[`${name}Validation`] || (validations || this.validations)[`${name}MutationValidation`];
      if (!mutation) {
        throw new Error(`Must have ${name} Mutation`);
      }
      if (returnMutation) return {
        mutation,
        validation
      };
      if (validation) try {
        this.validate(mutation, variables, validation);
      } catch (err) {
        console.error(err);
        throw err;
      }
      const apollo = customClient || (batch ? apolloBatchClient : apolloClient);
      const {
        data,
        errors
      } = await apollo.mutate(Object.assign({
        mutation,
        variables,
        context
      }, fetchPolicy ? {
        fetchPolicy
      } : {}, errorPolicy ? {
        errorPolicy
      } : {}));
      if (errors && errors.length > 0) {
        throw new Error(errors[0].message);
      }
      if (!keepTypeName) external_omit_deep_default()(data, "__typename");
      onLoading(false);
      if (fetchPolicy === "network-only" || !fetchPolicy && apollo.defaultOptions.mutate.fetchPolicy === "network-only") {
        await apollo.cache.reset();
      }
      return data[name];
    } catch (err) {
      onLoading(false);
      throw err;
    }
  }
  validate(gql = libs_required`gql`, input, schema = libs_required`schema`) {
    const {
      definitions
    } = gql;
    if (definitions.length === 0) throw new Error("No definitions in gql object");
    const args = definitions.reduce((result, definition) => {
      const {
        kind,
        selectionSet
      } = definition;
      if (kind !== "OperationDefinition") return result;
      const recursive = (selections, selectionSet, depth = 0) => {
        selections = selections.concat(selectionSet.selections);
        for (let i = 0; i < selectionSet.selections.length; i++) {
          const {
            selectionSet: childSelectionSet
          } = selectionSet.selections[i];
          if (childSelectionSet && i < depth) selections = recursive(selections, childSelectionSet);
        }
        return selections;
      };
      const selections = recursive([], selectionSet).filter(selection => selection.kind === "Field");
      return selections.reduce((result, selection) => {
        if (selection.arguments.length === 0) return result;
        result[selection.name.value] = selection.arguments.reduce((result, argument) => {
          const {
            name,
            value
          } = argument;
          return Object.assign(result, {
            [`${name.value}`]: value.name ? value.name.value : value.value
          });
        }, {});
        return result;
      }, {});
    }, {});
    for (const key in args) {
      if (args.hasOwnProperty(key) === false) continue;
      try {
        Object.assign(input, schema.validateSync(Object.keys(args[key]).reduce((result, name) => {
          result[name] = input[args[key][name]];
          return result;
        }, {})));
      } catch (err) {
        throw err;
      }
    }
    return true;
  }
}
/* harmony default export */ var Markup_0 = (Markup_Markup);
// CONCATENATED MODULE: ./index.js


let settings = {
  markup: {}
};
const registerMarkup = (markup = {}) => {
  settings["markup"] = Object.assign({}, settings["markup"], markup);
};
const registerApolloClient = apolloClient => {
  settings = Object.assign({}, settings, {
    apolloClient
  });
};
const registerApolloBatchClient = apolloBatchClient => {
  settings = Object.assign({}, settings, {
    apolloBatchClient
  });
};
const getSettings = () => settings;
/* harmony default export */ var index = __webpack_exports__["default"] = (Markup_0);

/***/ })
/******/ ]);
//# sourceMappingURL=index.js.map